import { Collapse, Flex, Spin, Input, Typography, Table, Layout, Space, Button, Tooltip, Drawer, Radio, Empty, App } from 'antd'
import { useEffect, useMemo, useState, useRef, isValidElement } from 'react'
import { Conditional } from '@/components/Conditional'

export const CustomerOrderList = ({ dataSource, onClick }) => {

  const [clickedOrder, setClickedOrder] = useState(0)

  useEffect(() => {
    if (dataSource && dataSource.length > 0) {
      setClickedOrder(dataSource[0])
    }
  }, [dataSource])

  const handleButtonClick = (item) => {
    setClickedOrder(item)
    if (onClick) {
      onClick(item)
    }
  }

  return (
    <Flex gap='small' wrap className='py-2'>
      <Conditional
        condition={dataSource && dataSource.length > 0}
        whenTrue={
          dataSource.map((item, _) => {
          const currentOrder = clickedOrder && clickedOrder.order_sn === item.order_sn
          const buttonColor = currentOrder ? 'primary' : 'default'
          const buttonVariant = currentOrder ? 'filled' : 'text'
            return (
              <Button key={item.order_sn} color={buttonColor} variant={buttonVariant}
                onClick={() => handleButtonClick(item)}>
                {item.order_id}
              </Button>
            )
          })
        }
        whenFalse={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      />
    </Flex>
  )
}